import { Component } from '@angular/core';

@Component({
    selector: 'r1-compass-lib-instructions-with-fields-container',
    imports: [],
    template: `
        <div>
            <div class="main-container">
                <div class="instructions-container">
                    <ng-content select="[instructions]" />
                </div>
                <div class="fields-container">
                    <ng-content select="[formArea]" />
                </div>
            </div>
        </div>
    `,
    styles: `
        .main-container {
            display: flex;
            margin-bottom: 20px;

            .instructions-container {
                width: 20%;
                margin-right: 15px;
            }

            .fields-container {
                width: 80%;
                background-color: var(--r1-faint-gray);
                padding: 20px;
            }
        }
    `,
})
export class InstructionsWithFieldsContainerComponent {}
